var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-water-trend"},[_c('div',{staticClass:"trend-chart"},[_c('Echart',{ref:"trendChart",staticStyle:{"height":"100%","width":"100%"},attrs:{"options":_vm.chartOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }